<div class="animation-container" *ngIf="!showHome">
    <div class="particles">
      <div class="particle" *ngFor="let particle of particles"></div>
    </div>
    <div class="welcome-message">
      <div class="welcome">Welcome to</div>
      <div class="safe-line">
        <div class="barcode-icon"><svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="green" class="bi bi-upc-scan me-2"
          viewBox="0 0 16 16">
          <path
            d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5M.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5M3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0z" />
        </svg></div>
        <div class="word">Safe</div>
        <div class="scan">Scan</div>
      </div>
    </div>
    <div class="loading-container">
      <div class="loading-bar">
        <div class="progress"></div>
      </div>
      <div class="loading-text">Initializing systems...</div>
    </div>
  </div>
   <app-batch *ngIf="showHome"></app-batch>